import universalLocalStorage from "../../utils/lib/universalLocalStorage";
import goTo from "../goTo";

export default async function saveUserAuth(data) {
  if (data) {
    await universalLocalStorage.setItem(
      "continental-security-token",
      data.token
    );
    await universalLocalStorage.setItem(
      "continental-security-userID",
      data.userID
    );

    window.doInitialLoad().then(() => {
      goTo("/")();
    });
  }
}
